/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Command } from '../../../model/Command';
import { Filter } from '../../../model/Filter';
import { ListController } from '../../ListController';

class GuaranteedRestoreTimePolicyListController extends ListController {
    /** @ngInject */
    constructor(guaranteedRestoreTimePolicyService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, configuration, domainService, siteService, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.guaranteedRestoreTimePolicyService = guaranteedRestoreTimePolicyService;
        this.domainService = domainService;
        this.siteService = siteService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'GrtList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.paging.sort = 'site.name';
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.siteFilter = Filter.equalFilterEmpty('site.id', 'model.site.site', 'SELECT_AUTOCOMPLETE', []);

        this.domainFilter = Filter.equalFilterEmpty('site.domain.id', 'model.domain.domain', 'SELECT', [],
            domainId => this.getFilterSites(domainId));

        this.filters.push(this.domainFilter, this.siteFilter);
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.grtpolicy.edit', 'images/svg/add.svg',
                'gmao.organization.grtpolicy.edit'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterDomains().then(() => this.getFilterSites(this.domainFilter.value));
    }

    /**
     * Gets the list of domains.
     *
     * @return {Object[]} Promise providing an array of domains.
     */
    getFilterDomains() {
        return this.filterService.getFilterOptions(this.domainService, this.domainFilter, 'name');
    }

    /**
     * Gets the list of sites for a given domain.
     *
     * @param {Number} [domainId] Domain ID, may be undefined if no domain is selected.
     * @return {Object[]} Promise providing an array of sites.
     */
    getFilterSites(domainId) {
        return this.filterService.getOrClearFilterOptions(this.siteService, this.siteFilter, 'name',
            [Filter.equalFilter('domain.id', domainId)], domainId);
    }

    /**
     * Reloads the list of GRT policies.
     *
     * @return {Promise} A promise providing the list of GRT policies.
     */
    reload() {
        return this.handleRestServiceCall(
            this.guaranteedRestoreTimePolicyService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting a policy. If the dialog is confirmed, the policy is deleted.
     *
     * @param {integer} Policy ID.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.grtpolicy.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deletePolicy(id).finally(() => {
                        this.reload();
                    })
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately a policy without confirmation, and reloads the list of policies.
     *
     * @param {integer} Policy ID.
     */
    deletePolicy(id) {
        return this.handleRestServiceCall(this.guaranteedRestoreTimePolicyService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.grtpolicy.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
        });
    }
}

export const guaranteedRestoreTimePolicyListComponent = {
    template: require('./guaranteedrestoretimepolicy-list.html'),
    controller: GuaranteedRestoreTimePolicyListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/GuaranteedRestoreTimePolicyList.js